import React, { PropTypes } from 'react';
import _intersection from 'lodash/intersection';
import { AuthTypes, Entitlements } from 'enums';
import { streamHasAuthType } from 'lib/auth';

// const isStreamEspnPlusBase = (packages = []) => (
//     packages.find(entitlement => entitlement === Entitlements.ESPN_PLUS)
// );

const isStreamEspnPlusMlb = (packages = []) => (
    packages.find(entitlement => entitlement === Entitlements.ESPN_PLUS_MLB)
);

const isStreamEspnPlusPPV = (packages = []) => (
    packages.find(
        entitlement => entitlement.includes(Entitlements.ESPN_PLUS_UFC_PPV)
    )
);

const isUserEntitled = (authTypes = [], userAuth = []) => {
    let isEntitled = [];
    if (Array.isArray(authTypes) && Array.isArray(userAuth)) {
        isEntitled = _intersection(authTypes, userAuth);
    }

    return isEntitled.length > 0;
};

export const getAuthLabel = ({ userAuth = [], streamContent = {} }) => {
    if (!streamContent || !streamContent.authTypes) {
        return null;
    }

    const { authTypes = [], packages = [] } = streamContent;
    let labelClass = 'button sm';
    let label = null;
    let labelText = '';
    let isEntitled = false;

    // E+ Event
    if (Array.isArray(packages) && packages.length > 0 && streamHasAuthType(streamContent, AuthTypes.BAM)) {
        isEntitled = isUserEntitled(packages, userAuth);
        if (isStreamEspnPlusPPV(packages)) { // Verify if PPV Event
            labelText = isEntitled ? 'PURCHASED' : 'BUY PPV';
        } else if (isStreamEspnPlusMlb(packages)) { // Verify if MLB Event
            labelText = isEntitled ? 'SUBSCRIBED TO ESPN+ MLB' : 'Get MLB.TV';
        } else {
            labelText = isEntitled ? 'SUBSCRIBED TO ESPN+' : 'ESPN+';
            labelClass = 'button sm espn-plus';
        }

        label = isEntitled ? (
            <div className="auth-label auth-label--dark">{labelText}</div>
        ) : (<button className={`${labelClass}`}>{labelText}</button>);
    } else if (streamHasAuthType(streamContent, AuthTypes.MVPD) || streamHasAuthType(streamContent, AuthTypes.ISP)) {
        isEntitled = isUserEntitled(authTypes, userAuth);
        labelText = isEntitled ? 'LOGGED INTO TV PROVIDER' : 'CHOOSE TV PROVIDER';
        label = isEntitled ? (
            <div className="auth-label auth-label--dark">{labelText}</div>
        ) : (
            <button className={`${labelClass}`}>{labelText}</button>
        );
    }

    return label;
};

const FeedsSelectorAuthPill = ({ userAuth, streamContent }) => (
    <div className="StreamingCard__Labels">
        {getAuthLabel({ userAuth, streamContent })}
    </div>
);

FeedsSelectorAuthPill.propTypes = {
    userAuth: PropTypes.array,
    streamContent: PropTypes.object
};

FeedsSelectorAuthPill.defaultProps = {
    userAuth: []
};

export default FeedsSelectorAuthPill;



// WEBPACK FOOTER //
// ./app/webapp/player/FeedsSelectorAuthPill.js